import React from 'react'
import url from 'libraries/front-end-core/core/url'
import { CURRENT_AWARENESS } from 'constants/controllers'
import Xml from 'components/shared/Xml'

const CaResultsItemSection = ({
  dateOfPublication,
  content,
  id,
  isArchived,
  title,
  owningAreaOfLaw,
  aol,
  isLogged,
  setSignUpModalIsOpen
}) => {
  const href = isLogged ? url(CURRENT_AWARENESS, { aol: owningAreaOfLaw, flavour: isArchived ? 'archive' : false, id }) : null
  const handleOnClick = (e) => {
    if (!isLogged) {
      e.preventDefault()
      setSignUpModalIsOpen(true)
    }
  }

  if (!content && !title) {
    return null
  }

  return (
    <li className='mt7 mb3'>
      {title && (
        <h2 className='ma0 lh-copy f5 fw6'>
          <a href={href} onClick={handleOnClick} className='black no-underline hover-cadet-blue pointer'>
            <span><Xml render={title} /></span>
          </a>
        </h2>
      )}
      <Breadcrumbs {...{ dateOfPublication }} />
      {content && (
        <span className='f5 lh-copy black'>
          {isLogged ? <Xml render={content} /> : <div style={{ width: '100%', height: '1rem' }} />}
        </span>
      )}
    </li>
  )
}

const Breadcrumbs = ({ dateOfPublication }) => (
  <div className='cadet-blue f7 mt2 mb3'>
    {dateOfPublication}
  </div>
)

export default CaResultsItemSection
